import { createAction } from '@reduxjs/toolkit';
export const CREATE_ANALYTIC_TEAM_REPORT_CONFIG = 'CREATE_ANALYTIC_TEAM_REPORT_CONFIG';
export const createAnalyticTeamReportConfigAction = createAction(CREATE_ANALYTIC_TEAM_REPORT_CONFIG);